import * as React from "react";

export const GameDownloadPage: React.FC = () => {
  return null;
};
